<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgment">
<h1>Acknowledgment</h1>
<p style="text-indent:00em; padding-top:15px;">Big thanks to my dad, Ken, for believing in the book and helping in the editing process.</p>
<p style="text-indent:00em; padding-top:15px;">To Ben for being the most loving and supportive partner.</p>
<p style="text-indent:00em; padding-top:15px;">To my sister Nat, family, and friends, thank you for supporting me, always.</p>
<p style="text-indent:00em; padding-top:15px;">Thanks to Austin Macauley for taking a chance on an unknown author.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?315ab61a